<template>
	<transition name="slide-down">
		<div class="invalid-feedback d-block"
		v-if="bag.length && bag[0] || error ">
			<i class="bi bi-exclamation-circle me-3"></i> 
			{{error ? error : bag[0]}}
		</div>
	</transition>
</template>

<script>

	import {mapState} from 'vuex'

	export default {

		props: {
			errors: String,
			error: String,
		},

		computed: {

			...mapState(['board']),

			bag() {
				var bag = this.$getErrors(this.errors)
				return _.isArray(bag) ? bag : [bag]
			}


		}
	}
</script>